import React from "react";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import theme from "../../utils/theme";

const IconButtons = ({
  buttonType,
  onClick,
  sx,
  disabled = false,
  ...props
}) => {
  const getIcon = () => {
    switch (buttonType) {
      case "delete":
        return <DeleteIcon fontSize="small" />;
      case "edit":
        return <EditIcon fontSize="small" />;
      case "info":
        return <InfoIcon fontSize="small" />;
      case "view":
        return <VisibilityIcon fontSize="small" />;
      case "add":
        return <AddIcon fontSize="small" />;
      case "close":
        return <CloseIcon fontSize="small" />;

      default:
        return <EditIcon fontSize="small" />;
    }
  };

  const getColor = () => {
    switch (buttonType) {
      case "delete":
        return theme.palette.error.dark;
      case "edit":
        return theme.palette.primary.main;
      case "info":
        return theme.palette.info.main;
      case "view":
        return theme.palette.info.main;
      case "add":
        return theme.palette.info.main;
      case "close":
        return theme.palette.primary.main;
      default:
        return theme.palette.primary.main;
    }
  };

  const getHoverColor = () => {
    switch (buttonType) {
      case "delete":
        return theme.palette.error.light;
      case "edit":
        return theme.palette.error.light;
      case "info":
        return theme.palette.info.light;
      case "view":
        return theme.palette.info.light;
      case "add":
        return theme.palette.info.light;
      case "close":
        return theme.palette.error.light;
      default:
        return theme.palette.primary.light;
    }
  };

  const getBorderColor = () => {
    switch (buttonType) {
      case "delete":
        return theme.palette.error.light;
      case "edit":
        return theme.palette.error.light;
      case "info":
        return theme.palette.info.light;
      case "view":
        return theme.palette.info.light;
      case "add":
        return theme.palette.info.light;
      case "close":
        return theme.palette.error.light;
      default:
        return theme.palette.primary.light;
    }
  };

  return (
    <IconButton
      aria-label={buttonType}
      onClick={onClick}
      disabled={disabled}
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: "4px",
        color: getColor(),
        p: 0.7,
        border: `1px solid ${getBorderColor()}`,
        boxShadow: `1px 1px 2px ${getBorderColor()}`,
        "&:hover:not(:disabled)": {
          backgroundColor: getHoverColor(),
          color: getColor(),
        },
        "&:disabled": {
          backgroundColor: theme.palette.background.default,
          color: theme.palette.grey[500],
        },
        ...sx, // Merge any additional sx props
      }}
      {...props}
    >
      {getIcon()}
    </IconButton>
  );
};

export default IconButtons;
